import { Button, Flex, Modal, Space, Typography } from "antd";

const { Text } = Typography;

export default function UberEatsDisconnectDialog({
  showModal,
  setShowModal,
  isLoading,
  handleProvision
}) {
  return (
    <Modal
      title="Warning"
      closable={false}
      centered={true}
      open={showModal}
      footer={null}
    >
      <Flex style={{ marginBottom: "20px" }}>
        <Space align="start" size="middle">
          <Space.Compact direction="vertical">
            <Text>
              You are about to remove your integration with Uber Eats. Do you want
              to proceed?
              <br /> <br />
              Removing integration with Bevz will stop your Uber Merchant store
              from working on ubereats.com
              <br /> <br />
              To ensure seamless provisioning/deprovision of store, you will need
              to logout from your{" "}
              <a
                href="https://riders.uber.com/v2/profile"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://riders.uber.com/v2/profile
              </a>
            </Text>
          </Space.Compact>
        </Space>
      </Flex>
      <Flex justify="end">
        <Space size="middle">
          <Button
            htmlType="button"
            disabled={isLoading}
            onClick={() => setShowModal(false)}
          >
            Cancel
          </Button>
          <Button
            htmlType="submit"
            color="danger"
            variant="solid"
            loading={isLoading}
            disabled={isLoading}
            onClick={handleProvision.bind(this, "remove")}
          >
            Proceed
          </Button>
        </Space>
      </Flex>
    </Modal>
  );
};